export default __webpack_public_path__ + "static/media/we_chat.e6838eb6f8aac94aa790fb508ab4b410.svg";